import {APP_EDITIONS} from '../constants/constants';
import {
  TOGGLE_SIDEBAR,
  REQUEST_INVITE_INFO,
  RECEIVE_INVITE_INFO,
  REQUEST_SP_INFO,
  RECEIVE_SP_INFO,
  RECEIVE_SAVE_SP_INFO,
  REQUEST_SAVE_SP_INFO,
  UPDATE_INFO_CONTACTOR,
  UPDATE_INFO_NAME,
  UPDATE_WECHAT_APP_ID,
  UPDATE_WECHAT_APP_SECRET,
  UPDATE_WECHAT_ENCODING_AES_KEY,
  REQUEST_WECHAT_INFO,
  RECEIVE_WECHAT_INFO,
  REQUEST_WECHAT_CLEAR_SETTING,
  RECEIVE_WECHAT_CLEAR_SETTING,
  REQUEST_SAVE_WECHAT_INFO,
  RECEIVE_SAVE_WECHAT_INFO,
  REQUEST_SAVE_FORM_INFO,
  RECEIVE_SAVE_FORM_INFO,
  REQUEST_FORM_LIST,
  RECEIVE_FORM_LIST,
  REQUEST_SHARED_FORM_LIST,
  RECEIVE_SHARED_FORM_LIST,
  REQUEST_FORM_INFO,
  RECEIVE_FORM_INFO,
  REQUEST_DEFAULT_FORM_INFO,
  RECEIVE_DEFAULT_FORM_INFO,
  REQUEST_MY_TICKET_LIST,
  RECEIVE_MY_TICKET_LIST,
  REQUEST_TICKET_DETAIL,
  RECEIVE_TICKET_DETAIL,
  REQUEST_CHANGE_PASSWORD,
  RECEIVE_CHANGE_PASSWORD,
  REQUEST_CREATE_WECHAT_MENU,
  RECEIVE_CREATE_WECHAT_MENU,
  REQUEST_BIND_YHL_TEAM,
  RECEIVE_BIND_YHL_TEAM,
  REQUEST_APPLY_SUB_DOMAIN,
  RECEIVE_APPLY_SUB_DOMAIN,
  REQUEST_SUBDOMAIN_LIST,
  RECEIVE_SUBDOMAIN_LIST,
  REQUEST_ACCOUNT_INFO,
  RECEIVE_ACCOUNT_INFO,
  REQUEST_ACCOUNT_RENEW,
  RECEIVE_ACCOUNT_RENEW,
  REQUEST_ACCOUNT_SZ_LIST,
  RECEIVE_ACCOUNT_SZ_LIST,
  REQUEST_SP_LIST,
  RECEIVE_SP_LIST,
  REQUEST_FETCH_WECHAT_MENU,
  RECEIVE_FETCH_WECHAT_MENU,
  REQUEST_SP_SETTING,
  RECEIVE_SP_SETTING,
  REQUEST_SAVE_SP_SETTING,
  RECEIVE_SAVE_SP_SETTING,
  REQUEST_FETCH_AUTHORIZER_LIST,
  RECEIVE_FETCH_AUTHORIZER_LIST,
  REQUEST_SERVICE_TICKET_DETAIL,
  RECEIVE_SERVICE_TICKET_DETAIL,
  REQUEST_FETCH_TICKET_STEPS,
  RECEIVE_FETCH_TICKET_STEPS,
  REQUEST_RM_LIST,
  RECEIVE_RM_LIST,
} from './mutation-types';

export default {
  [TOGGLE_SIDEBAR](state) {
    state.sidebarVisible = !state.sidebarVisible
  },
  [REQUEST_INVITE_INFO](state) {
    state.invite.loading = true;
  },
  [RECEIVE_INVITE_INFO](state, payload) {
    state.invite.loading = false;
    state.invite.url = payload.invite_info.invite_url;
    state.invite.qrcode = payload.invite_info.qr_code;
    state.invite.reportqrcodes = payload.invite_info.report_qr_codes || [];
    state.invite.reporturls = payload.invite_info.report_urls || [];
    state.invite.home_page_url = payload.invite_info.home_page_url;

    state.invite.is_apply_sub_domain = !!payload.sub_domain;
    if (state.invite.is_apply_sub_domain) {
      state.invite.sub_domain_name = payload.sub_domain.name;
      state.invite.sub_domain_status = payload.sub_domain.status;
    }

    state.invite.is_apply_own_domain = !!payload.own_domain;
    if (state.invite.is_apply_own_domain) {
      state.invite.own_domain_name = payload.own_domain.domain_name;
      state.invite.own_domain_status = payload.own_domain.status;
    }
  },
  [REQUEST_SP_INFO](state) {
    state.info.loading = true;
    state.info.saving = false;
  },
  [RECEIVE_SP_INFO](state, payload) {
    state.info.loading = false;
    state.info.saving = false;

    state.info.name = payload.name;
    state.info.contactor = payload.contactor;
    state.info.bind_sys_code = payload.bind_sys_code;
    state.info.yhl_team_name = payload.yhl_team_name;
    state.info.yhl_team_id = payload.yhl_team_id;
    state.info.yhl_branch_id = payload.yhl_branch_id;
    state.info.contact_phone = payload.contact_phone;
    state.info.address = payload.address;
    state.info.email = payload.email;
    state.info.about_content = payload.about_content;
    state.info.logo = payload.logo;
    state.info.sub_domain = payload.sub_domain;
    state.info.spec = payload.spec;
    state.info.login_account = payload.login_account;
    state.info.active_edition = APP_EDITIONS[payload.spec];
    state.info.use_we_chat_third_party_platform = payload.use_we_chat_third_party_platform;

    const
      expire_date = new Date(payload.expire_date),
      now = new Date(),
      millisecondsPerDay = 1000 * 60 * 60 * 24,
      millisBetween = expire_date.getTime() - now.getTime(),
      left_days = millisBetween / millisecondsPerDay;

    state.info.expire_date = expire_date;
    state.info.left_days = left_days;
  },
  [REQUEST_SAVE_SP_INFO](state) {
    state.info.loading = false;
    state.info.saving = true;
  },
  [RECEIVE_SAVE_SP_INFO](state, payload) {
    state.info.loading = false;
    state.info.saving = false;

    state.info.name = payload.name;
    state.info.contactor = payload.contactor;
  },
  [UPDATE_INFO_CONTACTOR](state, value) {
    state.info.contactor = value;
  },
  [UPDATE_INFO_NAME](state, value) {
    state.info.name = value;
  },
  [UPDATE_WECHAT_APP_ID](state, value) {
    state.wechat.app_id = value;
  },
  [UPDATE_WECHAT_APP_SECRET](state, value) {
    state.wechat.app_secret = value;
  },
  [UPDATE_WECHAT_ENCODING_AES_KEY](state, value) {
    state.wechat.encoding_aes_key = value;
  },
  [REQUEST_WECHAT_INFO](state) {
    state.wechat.loading = true;
    state.wechat.saving = false;
  },
  [REQUEST_WECHAT_CLEAR_SETTING](state) {
    state.wechat.loading = false;
    state.wechat.saving = true;
  },
  [RECEIVE_WECHAT_INFO](state, payload) {
    state.wechat.loading = false;
    state.wechat.saving = false;

    state.wechat.is_empty = payload === null;

    if (payload !== null) {
      state.wechat.app_id = payload.app_id;
      state.wechat.app_secret = payload.app_secret;
      state.wechat.encoding_aes_key = payload.encoding_aes_key;
      state.wechat.token = payload.token;
      state.wechat.server_ip = payload.server_ip;
      state.wechat.callback_url = payload.callback_url;
      state.wechat.verified_domain = payload.verified_domain;
      state.wechat.qr_code = payload.qr_code;
      state.wechat.is_template_message_enabled = payload.is_template_message_enabled;
      state.wechat.ticket_progress_changed_template_id = payload.ticket_progress_changed_template_id;
      state.wechat.transfer_message_to_kf_system = payload.transfer_message_to_kf_system;
    }
  },
  [RECEIVE_WECHAT_CLEAR_SETTING](state) {
    state.wechat.loading = false;
    state.wechat.saving = false;

    state.wechat.app_id = '';
    state.wechat.app_secret = '';
    state.wechat.encoding_aes_key = '';
    state.wechat.token = '';
    state.wechat.server_ip = '';
    state.wechat.callback_url = '';
    state.wechat.verified_domain = '';
  },
  [REQUEST_SAVE_WECHAT_INFO](state) {
    state.wechat.loading = false;
    state.wechat.saving = true;
  },
  [RECEIVE_SAVE_WECHAT_INFO](state) {
    state.wechat.loading = false;
    state.wechat.saving = false;
  },
  [REQUEST_SAVE_FORM_INFO](state) {
    state.form.loading = false;
    state.form.saving = true;
  },
  [RECEIVE_SAVE_FORM_INFO](state) {
    state.form.loading = false;
    state.form.saving = false;
  },
  [REQUEST_FORM_LIST](state) {
    state.form.loading = true;
    state.form.saving = false;
  },
  [RECEIVE_FORM_LIST](state, payload) {
    state.form.loading = false;
    state.form.saving = false;
    state.form.list = payload.collection;
    state.form.total = payload.total_records;
  },
  [REQUEST_SHARED_FORM_LIST](state) {
    state.form.loading = true;
    state.form.saving = false;
  },
  [RECEIVE_SHARED_FORM_LIST](state, payload) {
    state.form.loading = false;
    state.form.saving = false;
    state.form.shared_list = payload.collection;
    state.form.shared_total = payload.total_records;
  },
  [REQUEST_FORM_INFO](state) {
    state.form.loading = true;
    state.form.saving = false;
  },
  [RECEIVE_FORM_INFO](state, payload) {
    state.form.loading = false;
    state.form.saving = false;
  },
  [REQUEST_DEFAULT_FORM_INFO](state) {
    state.form.df_loading = true;
  },
  [RECEIVE_DEFAULT_FORM_INFO](state, payload) {
    state.form.df_loading = false;
    state.form.df = payload;
  },
  [REQUEST_MY_TICKET_LIST](state) {
    state.report_list.loading = true;
  },
  [RECEIVE_MY_TICKET_LIST](state, payload) {
    state.report_list.loading = false;
    state.report_list.columns = payload.column_map;
    state.report_list.data = payload.collection;
    state.report_list.total = payload.total_records;
    state.report_list.additional_parameters = payload.additional_parameters || {};
  },
  [REQUEST_TICKET_DETAIL](state) {
    state.report_detail.loading = true;
  },
  [RECEIVE_TICKET_DETAIL](state, payload) {
    state.report_detail.loading = false;
    state.report_detail.ticket = payload.html;
    state.report_detail.no = payload.no;
    state.report_detail.videos = payload.videos;
    state.report_detail.voices = payload.voices;
    state.report_detail.attachments = payload.attachments;
  },
  [REQUEST_CHANGE_PASSWORD](state) {
    state.info.saving = true;
  },
  [RECEIVE_CHANGE_PASSWORD](state) {
    state.info.saving = false;
  },
  [REQUEST_CREATE_WECHAT_MENU](state) {
    state.wechat_menu.loading = false;
    state.wechat_menu.saving = true;
  },
  [RECEIVE_CREATE_WECHAT_MENU](state) {
    state.wechat_menu.loading = false;
    state.wechat_menu.saving = false;
  },
  [REQUEST_BIND_YHL_TEAM](state) {
    state.info.saving = true;
  },
  [RECEIVE_BIND_YHL_TEAM](state) {
    state.info.saving = false;
  },
  [REQUEST_APPLY_SUB_DOMAIN](state) {
    state.invite.loading = true;
  },
  [RECEIVE_APPLY_SUB_DOMAIN](state) {
    state.invite.loading = false;
  },
  [REQUEST_SUBDOMAIN_LIST](state) {
    state.sub_domain_list.loading = true;
  },
  [RECEIVE_SUBDOMAIN_LIST](state, payload) {
    state.sub_domain_list.loading = false;
    state.sub_domain_list.data = payload.collection;
    state.sub_domain_list.total = payload.total_records;
  },
  [REQUEST_ACCOUNT_INFO](state) {
    state.account_info.loading = true;
  },
  [RECEIVE_ACCOUNT_INFO](state, payload) {
    state.account_info.loading = false;
    state.account_info.spec = payload.spec;
    state.account_info.can_renew_service = payload.spec > 0;
    state.account_info.can_upgrade_edition = payload.spec < 2;
    state.account_info.active_edition = APP_EDITIONS[payload.spec];

    const
      expire_date = new Date(payload.expire_date),
      now = new Date(),
      millisecondsPerDay = 1000 * 60 * 60 * 24,
      millisBetween = expire_date.getTime() - now.getTime(),
      left_days = millisBetween / millisecondsPerDay;

    state.account_info.expire_date = expire_date;
    state.account_info.left_days = left_days;
  },
  [REQUEST_ACCOUNT_RENEW](state) {

  },
  [RECEIVE_ACCOUNT_RENEW](state, payload) {

  },
  [REQUEST_ACCOUNT_SZ_LIST](state) {
    state.account_info.list_loading = true;
  },
  [RECEIVE_ACCOUNT_SZ_LIST](state, payload) {
    state.account_info.list_loading = false;
    state.account_info.list_data = payload.collection;
    state.account_info.list_total = payload.total_records;
  },
  [REQUEST_SP_LIST](state) {
    state.sp_list.loading = true;
  },
  [RECEIVE_SP_LIST](state, payload) {
    state.sp_list.loading = false;
    state.sp_list.data = payload.collection;
    state.sp_list.total = payload.total_records;
  },
  [REQUEST_FETCH_WECHAT_MENU](state) {
    state.wechat_menu.loading = true;
    state.wechat_menu.saving = false;
  },
  [RECEIVE_FETCH_WECHAT_MENU](state, payload) {
    state.wechat_menu.loading = false;
    state.wechat_menu.saving = false;
    state.wechat_menu.menu = payload;
  },
  [REQUEST_SP_SETTING](state) {
    state.setting.loading = true;
    state.setting.saving = false;
  },
  [RECEIVE_SP_SETTING](state, payload) {
    state.setting.loading = false;
    state.setting.saving = false;
    state.setting.setting = payload;
  },
  [REQUEST_SAVE_SP_SETTING](state) {
    state.setting.loading = false;
    state.setting.saving = true;
  },
  [RECEIVE_SAVE_SP_SETTING](state) {
    state.setting.loading = false;
    state.setting.saving = false;
  },
  [REQUEST_FETCH_AUTHORIZER_LIST](state) {
    state.wechat_menu.loading = true;
    state.wechat_menu.saving = false;
  },
  [RECEIVE_FETCH_AUTHORIZER_LIST](state, payload) {
    state.wechat_menu.loading = false;
    state.wechat_menu.saving = false;
  },
  [REQUEST_SERVICE_TICKET_DETAIL](state) {
    state.report_detail.loading = true;
    state.report_detail.service_ticket_loaded = false;
    state.report_detail.service_ticket = null;
  },
  [RECEIVE_SERVICE_TICKET_DETAIL](state, payload) {
    state.report_detail.loading = false;
    state.report_detail.service_ticket_loaded = true;
    state.report_detail.service_ticket = payload;
  },
  [REQUEST_FETCH_TICKET_STEPS](state) {
    state.report_steps.querying = true;
    state.report_steps.steps = [];
    state.report_steps.current = 0;
  },
  [RECEIVE_FETCH_TICKET_STEPS](state, payload) {
    state.report_steps.querying = false;
    if (payload) {
      state.report_steps.steps = payload.steps;
      state.report_steps.current = payload.current_step;
    }
  },
  [REQUEST_RM_LIST](state) {
    state.repair_member_list.loading = true;
  },
  [RECEIVE_RM_LIST](state, payload) {
    state.repair_member_list.loading = false;
    state.repair_member_list.data = payload.collection;
    state.repair_member_list.total = payload.total_records;
  },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js